let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("V9B1k")).then(() => parcelRequire('8sTMU'));